
<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
export default {
  data() {
    return {

    }
  },
  mounted() {
    // 商户查询列表
    post(api.nameList)
    .then((d) => {
        console.log(d,'商户')
        if (d.status === 0) {
          var arr = []
          for (let i = 0; i < d.data.length; i++) {
            var obj = {
              id : d.data[i].id,
              value : d.data[i].name,
              divide: d.data[i].businessmenDivide
            }
            arr.push(obj)
          }
          console.log(arr)
          localStorage.setItem('merchantsList',JSON.stringify(arr))
        }
    }, (err) => {
        //error callback
    })
  },
  methods: {

  },
  components: {

  },
  created() {
    // if (this.$router.history.current.path == '/merchants') {
    //   this.$router.push({path: '/merchants/businessInformation'})
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/merchants/merchants.vue